function IntegerToRomanFilter() {
  'ngInject';
  return function (input) {
    if (typeof input !== 'number')
      return false;

    var digits = String(+input).split(""),
      key = ["", "c", "cc", "ccc", "cd", "d", "dc", "dcc", "dccc", "cm",
        "", "x", "xx", "xxx", "xl", "l", "lx", "lxx", "lxxx", "xc",
        "", "i", "ii", "iii", "iv", "v", "vi", "vii", "viii", "ix"],
      roman_num = "",
      i = 3;
    while (i--)
      roman_num = (key[+digits.pop() + (i * 10)] || "") + roman_num;
    return Array(+digits.join("") + 1).join("m") + roman_num;
  };
}
export default {
  name: 'IntegerToRomanFilter',
  fn: IntegerToRomanFilter
};
